import { Account } from '@ui/src';
import { CASP } from '@ui/src/components/transactions-sidepanels/types';
import { PspPartner, PspIntegrationPayment, OrganizationType } from '../types';

export interface ExternalAccount {
  account: Account & { organization: { type: string } };
  accountId: string;
  iban: string;
  id: string;
  pspIntegrationConnectionId: string;
  pspIntegrationPayment?: PspIntegrationPayment;
  pspIntegrationPaymentId?: string;
  pspPartner?: PspPartner;
  bank?: string;
  currencyId?: string;
  paymentType?: string;
  accountNumber?: string;
  accountName?: string;
  accountType?: string;
  active?: boolean;
  createdAt?: string;
  createType?: string;
  caspId?: string;
  url?: string;
  currenciesIds?: string[];
  pspIntegrationPaymentAccountsCount?: number;
  render?: Record<string, React.JSX.Element>;
}

export interface ExternalOrganizationAccount {
  currencies: string[];
  id: string;
  externalId: string;
}

export interface ExternalAccountFormValues {
  pspPartnerId: string;
  accountId: string;
  iban: string;
  paymentType: string;
  currencyId: string[];
  status?: string;
  active: boolean;
  caspId?: string;
  casp?: CASP[];
  currenciesIds: string[];
}

export interface ExternalAccountWithIntegrationFormValues {
  accountsIds: string[];
  integrationId: string;
  currenciesIds: string[];
  caspId?: string;
}

export interface ExternalAccountToClientAccountFormValues {
  pspPartnerId: string;
  accountId: string;
  externalId: string;
  caspId?: string;
}

export interface ExternalAccountTopUpOption {
  accountNumber: string;
  bankAccountHolderName: string;
  bankAddress: string;
  bankCountry: string;
  bankName: string;
  bic: string;
  createdAt: string;
  currencyId: string;
  iban: string;
  id: string;
  paymentType?: string;
  pspIntegrationAccountId: string;
  thirdPartyIntegrationId?: string;
  thirdPartyReference?: string;
  routingCodeEntries?: {
    id?: string;
    routingCodeKey: string;
    routingCodeValue: string;
  }[];
}

export interface ExternalOrganization {
  organizationId: string;
  organizationType: OrganizationType;
  externalId: string;
  active: boolean;
  id: string;
  createdAt: string;
}

export interface ExternalOrganizationFormValues {
  organizationId: string;
  organizationType: OrganizationType;
  externalId: string;
  active: boolean;
  pspPartnerId: string;
}

export interface LinkedClient {
  active: boolean;
  createdAt: string;
  externalId: string;
  id: string;
  organizationId: string;
  organization: {
    firstName?: string;
    lastName?: string;
    companyName?: string;
    id: string;
  };
  organizationType: string;
  pspPartnerId?: string;
  render?: Record<string, React.JSX.Element>;
}

export interface ExternalAccountTopUpOptionFormValues {
  id?: string;
  paymentType: string;
  currencyId: string;
  bankAccountHolderName: string;
  accountNumber: string;
  bankAddress: string;
  bic: string;
  iban: string;
  bankName: string;
  thirdPartyReference?: string;
  pspIntegrationAccountId?: string;
  routingCodeEntries?:
    | {
        id?: string;
        routingCodeKey: string;
        routingCodeValue: string;
      }[]
    | null;
}

export enum RoutingCodeKeyEnum {
  ABA = 'ABA',
  BLZ_CODE = 'BLZ_CODE',
  BRANCH_CODE = 'BRANCH_CODE',
  BSB_CODE = 'BSB_CODE',
  SORT_CODE = 'SORT_CODE',
  IFS_CODE = 'IFS_CODE',
  CLABE_CODE = 'CLABE_CODE',
  CTN = 'CTN',
}
